import { render, staticRenderFns } from "./wrongPop.vue?vue&type=template&id=8189f2ca&scoped=true&"
import script from "./wrongPop.vue?vue&type=script&lang=js&"
export * from "./wrongPop.vue?vue&type=script&lang=js&"
import style0 from "./wrongPop.vue?vue&type=style&index=0&id=8189f2ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8189f2ca",
  null
  
)

export default component.exports